const localUrl = import.meta.env.VITE_BASE_URL;

// const localUrl = 'https://deliveryman.gr:3015';
// const localUrl = 'https://solvd.website:3015';
//
export const burl =
	process.env.NODE_ENV !== 'development' ? import.meta.env.VITE_BASE_URL : localUrl;

export const ORDER_URL = burl + '/shop/orders/';
export const CLIENT_URL = burl + '/shop/clients/';
export const SHOP_URL = burl + '/admin/shops/';
export const DELIVERY_URL = burl + '/admin/deliveries/';
export const ADMIN_URL = burl + '/master/admins/';
export const CITY_URL = burl + '/master/cities/';
export const DASHBOARD_CITIES_URL = burl + '/master/dashboard/cities';
export const DASHBOARD_API_KEYS_URL = burl + '/master/dashboard/api-keys';
export const DASHBOARD_GOOGLE_REQUESTS_URL = burl + '/master/dashboard/google-requests';
export const DASHBOARD_INTEREST_URL = burl + '/master/dashboard/interest-requests';
export const DASHBOARD_INTEREST_COUNT_URL = burl + '/master/dashboard/interest-requests/count';
// The public website's interest form (no login).
export const PUBLIC_INTEREST_URL = burl + '/public/interest/';
// The public website's order page for private customers (no login).
export const PUBLIC_ORDER_URL = burl + '/public/order/';
export const SETTINGS_URL = burl + '/shop/settings/';
export const STATISTICS_URL = burl + '/admin/statistics/';
export const CLOCKS_URL = burl + '/admin/clocks/';
export const SHIFTS_URL = burl + '/admin/shifts/';
export const RIDER_COSTS_URL = burl + '/admin/rider-costs/';
export const COMM_URL = burl + '/comm/';
export const ORDER_EVENTS_URL = burl + '/admin/order-events/';
export const ASSIGNMENT_DECISIONS_URL = burl + '/admin/assignment-decisions/';
export const LOGIN_URL = burl + '/auth/login/';
export const PROFILE_URL = burl + '/profile/';
